import React, { useEffect, useState } from "react";
import IssueInboxGrid from "./IssueInboxGrid";

import { connect } from "react-redux";
import {
  fetchAddressIssueTypesRequest,
  fetchAddressIssueTypesSuccess,
  fetchAddressIssueTypesFailure,
} from "../../redux/reducers/addressIssueTypesReducer"; //TODO move this to actions
import {
  fetchAddressIssueStatusTypesRequest,
  fetchAddressIssueStatusTypesSuccess,
  fetchAddressIssueStatusTypesFailure,
} from "../../redux/reducers/addressIssueStatusTypesReducer"; //TODO move these to actions

import {
  getAddressIssueTypes,
  getAddressIssueStatuTypes,
} from "../../serviceClients/addressingClient";
import {
  addressIssueTypesMapper,
  addressIssueStatusTypesMapper,
  addressingApiResponseMapper,
} from "../mappers/addressingMappers";
import IssueDetailsDisplay from "./IssueDetailsDisplay";

function IssuesInbox(props) {
  const [singleIssueDetails, setSingleIssueDetails] = useState({ data: [] });
  const [refreshGridValue, setRefreshGridValue] = useState(1);

  const refreshGrid = () => {
    setRefreshGridValue(refreshGridValue + 1);
  };

  useEffect(() => {
    // Get Address Issue Types
    const [promise, source] = getAddressIssueTypes(
      props.settings.userCredentials.token.access_token
    );
    promise
      .then((resp) => {
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(resp.data);
        if (isSuccess)
          props.fetchedAddressIssueTypesSuccessfully(
            addressIssueTypesMapper(respData, props.settings.language)
          );
        else props.fetchAddressIssueTypesFailed(message);
      })
      .catch((err) => {
        console.log(err.message);
        props.fetchAddressIssueTypesFailed(err.message);
      });

    // Get Address_Issue_Statu_Types
    const [promise2, source2] = getAddressIssueStatuTypes(
      props.settings.userCredentials.token.access_token
    );
    promise2
      .then((resp) => {
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(resp.data);
        if (isSuccess)
          props.fetchedAddressIssueStatusTypesSuccessfully(respData);
        else props.fetchAddressIssueStatusTypesFailed(message);
      })
      .catch((err) => {
        console.log(err.message);
        props.fetchAddressIssueStatusTypesFailed(err.message);
      });

    return () => {
      if (source) source.cancel();
      // if(source2) source2.cancel()
    };
  }, []);

  return (
    //TODO show loader while the IssueTypes are in loading
    <>
      {props.addressIssueTypesStateStore.data.length > 0 &&
      props.addressIssueTypesStateStore.data.length > 0 ? (
        <IssueInboxGrid
          refreshGridValue={refreshGridValue}
          refreshGrid={() => {
            refreshGrid();
          }}
          showIssueDetails={(issueData) => {
            setSingleIssueDetails({ data: [issueData] });
          }}
        />
      ) : null}
      {singleIssueDetails.data.length > 0 && (
        <IssueDetailsDisplay
          open={singleIssueDetails.data.length > 0}
          onClose={() => {
            setSingleIssueDetails({ data: [] });
            refreshGrid();
          }}
          issueInfo={singleIssueDetails}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    settings: state.settings,
    addressIssueTypesStateStore: state.addressIssueTypes,
    addressIssueStatusStateStore: state.addressIssueStatusTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAddressIssueTypes: () => dispatch(fetchAddressIssueTypesRequest()),
    fetchedAddressIssueTypesSuccessfully: (data) =>
      dispatch(fetchAddressIssueTypesSuccess(data)),
    fetchAddressIssueTypesFailed: (errMessage) =>
      dispatch(fetchAddressIssueTypesFailure(errMessage)),

    fetchAddressIssueStatusTypes: () =>
      dispatch(fetchAddressIssueStatusTypesRequest()),
    fetchedAddressIssueStatusTypesSuccessfully: (data) =>
      dispatch(fetchAddressIssueStatusTypesSuccess(data)),
    fetchAddressIssueStatusTypesFailed: (errMessage) =>
      dispatch(fetchAddressIssueStatusTypesFailure(errMessage)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IssuesInbox);
